module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "plans-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "plans-main-content"
    }
  }, [_c('div', {
    staticClass: "form-beneficios"
  }, [_c('div', {
    attrs: {
      "id": "beneficios-container"
    }
  }, [_c('div', {
    staticClass: "card-container",
    attrs: {
      "id": "card-one"
    }
  }, [_vm._m(0), _vm._v(" "), (!_vm.isMobile) ? _c('ul', {
    staticClass: "lista-beneficios"
  }, [_vm._m(1), _vm._v(" "), (_vm.isAdhesionFree === 0) ? _c('li', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("Adesão grátis")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("Sem mensalidade")]), _vm._v(" "), _c('li', [_vm._v("Sem vínculo com o cartão de crédito")]), _vm._v(" "), _c('li', [_vm._v("Receba sua TAG em casa ou retire em um parceiro")])]) : _vm._e()]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-container",
    attrs: {
      "id": "last-card"
    }
  }, [_vm._m(3), _vm._v(" "), (_vm.isMobile) ? _c('ul', {
    staticClass: "lista-beneficios"
  }, [_vm._m(4), _vm._v(" "), (_vm.isAdhesionFree === 0) ? _c('li', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("Adesão grátis")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("Sem mensalidade")]), _vm._v(" "), _c('li', [_vm._v("Sem vínculo com o cartão de crédito")]), _vm._v(" "), _c('li', [_vm._v("Receba sua TAG em casa ou retire em um parceiro")])]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "id": "flag-absolute",
      "src": require("./triangulo.svg")
    }
  })])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cards-container"
    }
  }, [_c('PlanInfoPf'), _vm._v(" "), _c('PlanInfo')], 1), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "vale-pedagio-text"
    }
  }, [_vm._v("Receba seu Vale-pedágio com tranquilidade.")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('Footer', {
    attrs: {
      "id": "footer-hotsite"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "align-card-title"
  }, [_c('img', {
    attrs: {
      "src": require("./icon-mapa_cobertura.svg")
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Cobertura nacional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("Possibilidade de receber "), _c('b', [_vm._v("Vale-pedágio")]), _vm._v(" de qualquer contratante")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-container"
  }, [_c('div', {
    staticClass: "align-card-title"
  }, [_c('img', {
    attrs: {
      "src": require("./icon-controle-total.svg")
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Controle total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "align-card-title"
  }, [_c('img', {
    attrs: {
      "src": require("./icon-24hours.svg")
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Atendimento 24h")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("Possibilidade de receber "), _c('b', [_vm._v("Vale-pedágio")]), _vm._v(" de qualquer contratante")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "plans-title"
    }
  }, [_c('p', {
    staticClass: "textPlans"
  }, [_vm._v("+ para você e sua empresa")]), _vm._v(" "), _c('h3', [_vm._v("Planos")]), _vm._v(" "), _c('h5', [_vm._v("\n        Temos planos que com certeza um deles é ideal para você, é só\n        escolher:\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "graph-container"
    }
  }, [_c('div', [_c('h1', [_vm._v("+80")]), _vm._v(" "), _c('h3', [_vm._v("Concessionárias")])]), _vm._v(" "), _c('div', [_c('h1', [_vm._v("+410")]), _vm._v(" "), _c('h3', [_vm._v("Praças de pedágio")])]), _vm._v(" "), _c('div', [_c('h1', [_vm._v("+1100")]), _vm._v(" "), _c('h3', [_vm._v("Pistas com pedágio automático")])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-59dbe89c!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/hotsite/components/plans/plans.vue
// module id = 2137
// module chunks = 1